module.exports = __webpack_public_path__ + "img/edit.c94f41cf.svg";